// extracted by mini-css-extract-plugin
export var actionIcon = "_pp-0";